module.exports = __webpack_public_path__ + "static/media/teemaLogo.6bf087c0.svg";